import instance from "../axios";
import { getUserToken } from "./userAuthenticate";

// load templates from api
export const loadTemplatesData = async (forPhysical = false) => {
  try {
    // Updated: Add query parameter to URL
    const url = `/giftcard/products/templates/get${forPhysical ? '?forPhysical=true' : ''}`
    const headers = {
      Authorization: getUserToken(),
    }

    // Removed forPhysical from payload since it's now in the URL
    const res = await instance.post(url, {}, { headers })
    return res.data
  } catch (e) {
    return { success: false, message: e.message, data: "" }
  }
}


export const addTemplateToDb = async (
  img_url,
  category = "",
  forPhysical = false
) => {
  try {
    // Updated: Add query parameter to URL
    const url = `/giftcard/products/templates/add${forPhysical ? '?forPhysical=true' : ''}`
    const headers = {
      Authorization: getUserToken(),
    }

    const payload = [{
      attachment: img_url,
      category,
      // Removed forPhysical from payload since it's now in the URL
    }]

    const res = await instance.post(url, { templates: payload }, { headers })
    return res.data
  } catch (e) {
    return { success: false, message: e.message, data: "" }
  }
}

export const createNewCategory = async (category) => {
  try {
    const url = "/giftcard/products/templates/add-category"
    const headers = {
      Authorization: getUserToken(),
    }
    const payload = {
      newCategory: category
    }
    const res = await instance.post(url, payload, { headers })
    const data = await res.data
    return data
  } catch (e) {
    return { success: false, message: e.message, data: "" }
  }
}

export const addCoverImageInCategory = async (coverImgBase64, category) => {
  try {
    const url = "/giftcard/products/templates/add-category-cover"
    const headers = {
      Authorization: getUserToken(),
    }
    const payload = {
      category,
      coverImages: [coverImgBase64]
    }
    const res = await instance.post(url, payload, { headers })
    const data = await res.data
    return data
  } catch (e) {
    return { success: false, message: e.message, data: "" }
  }
}

export const removeCategory = async (item) => {
  try {
    const url = "/mail-template/category/delete"
    const headers = {
      Authorization: getUserToken(),
    }
    const payload = {
      categoryName: item.category
    }
    const res = await instance.post(url, payload, { headers })
    const data = await res.data
    return data
  } catch (e) {
    return { success: false, message: e.message, data: "" }
  }
}